import React from 'react';
import { Bell } from 'lucide-react';

const NotificationSettings = ({ notifications, onToggle }) => {
  return (
    <div className="bg-white rounded-lg border border-black p-3 sm:p-4 md:p-6">
      <div className="flex items-center space-x-2 mb-3 sm:mb-4">
        <Bell className="w-4 h-4 sm:w-5 sm:h-5 text-black flex-shrink-0" />
        <h2 className="text-lg sm:text-xl font-bold text-black">Notifications</h2>
      </div>
      <div className="space-y-3">
        {Object.entries(notifications).map(([key, value]) => (
          <div key={key} className="flex items-center justify-between py-2">
            <label className="text-xs sm:text-sm font-medium text-gray-700 capitalize flex-1 pr-4">
              {key.replace(/([A-Z])/g, ' $1').trim()}
            </label>
            <button
              onClick={() => onToggle(key)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors flex-shrink-0 active:scale-95 ${
                value ? 'bg-black' : 'bg-gray-300'
              }`}
              aria-label={`Toggle ${key}`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  value ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationSettings;

